<script setup lang="ts">
import type { FilterButtonProps } from '.';

import { Button as UiButton } from '@/components/ui/button';

import { filterButtonVariants } from '.';

defineOptions({
	inheritAttrs: false
});

const props = withDefaults(defineProps<FilterButtonProps>(), {
	numberOfAppliedFilters: 0,
	showNumberOfAppliedFilters: true,
	label: '',
	variant: 'primary'
});

const isActive = defineModel<boolean>('isActive', {
	required: false,
	default: false
});

const numberOfAppliedFilters = computed<string>(() => {
	if (!props.numberOfAppliedFilters) return '';

	return props.numberOfAppliedFilters > 9
		? '9+'
		: props.numberOfAppliedFilters.toString();
});
</script>

<template>
	<UiButton
		variant="primary-light-4"
		:class="filterButtonVariants({ variant: variant })"
		:data-is-active="isActive"
		:data-is-applied="!!numberOfAppliedFilters"
		v-bind="$attrs"
		@click="isActive = !isActive"
	>
		<slot name="label" :label="label">
			{{ label }}
		</slot>
		<slot name="tag" :number-of-applied-filters="numberOfAppliedFilters">
			<div
				v-if="numberOfAppliedFilters && showNumberOfAppliedFilters"
				class="size-5 items-center justify-center rounded-full bg-primary-light-2 text-center text-xs font-medium leading-[18px] text-white lg:flex"
			>
				<span>
					{{ numberOfAppliedFilters }}
				</span>
			</div>
		</slot>
		<slot name="icon" :is-active="isActive" />
	</UiButton>
</template>
